import { Modal } from "antd";
import DelayForm from "./delayForm";

interface Props {
  open: boolean;
  // onClose: () => void;
  videoId: number;
  onSuccess: () => void;
}

function DelayFormModal({ open,videoId , onSuccess}: Props) {
  return (
    <Modal
      title="Reason for Delay"
      open={open}
      footer={null}
      destroyOnClose
      centered
      width={600}
    >
      <DelayForm videoId={videoId}  onSuccess={onSuccess} />
    </Modal>
  );
}

export default DelayFormModal;